const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/\s+/g, " ");

function levenshtein(a, b) {
  const row = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    let prev = row[0];
    row[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const tmp = row[j];
      row[j] = Math.min(row[j] + 1, row[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = tmp;
    }
  }
  return row[b.length];
}

const close = (a, b) => !!a && !!b && a !== b && levenshtein(a, b) <= (Math.min(a.length, b.length) >= 8 ? 2 : 1);
const tokens = (s) => s.split(" ").sort().join(" ");

export const contactLabel = (c) =>
  [[c.contact_gender, c.contact_name].filter(Boolean).join(" ") || c.contact_email, c.contact_name && c.contact_email ? c.contact_email : ""]
    .filter(Boolean).join(" · ");

export function sameContact(c, v) {
  const ce = norm(c.contact_email), ve = norm(v.contact_email);
  if (ce && ve) return ce === ve;
  const cn = norm(c.contact_name);
  return !!cn && cn === norm(v.contact_name);
}

// Contacts that look like a typo / near-duplicate of the typed value.
export function findSimilarContacts(list, v) {
  const vn = norm(v.contact_name), ve = norm(v.contact_email);
  if (!vn && !ve) return [];
  return list.filter((c) => !sameContact(c, v)).map((c) => {
    const cn = norm(c.contact_name), ce = norm(c.contact_email);
    if (close(ce, ve)) return { contact: c, reason: "Email très proche (faute de frappe ?)" };
    if (vn && cn === vn) return { contact: c, reason: "Même nom, email différent" };
    if (vn && cn && (close(cn, vn) || tokens(cn) === tokens(vn))) return { contact: c, reason: "Nom très proche (faute de frappe ?)" };
    if (ve && ce && ce.split("@")[0] === ve.split("@")[0]) return { contact: c, reason: "Même identifiant email, domaine différent" };
    return null;
  }).filter(Boolean);
}
